import httpClient from '@/core/http/client.service';
import Login from '@/core/api/auth/Login.class';
import User from '@/core/api/auth/User.class';
// import _ from 'lodash';

export default {
  state: {
    authenticated: false,
    user: {
      userId: '',
      firstName: '',
      lastName: '',
      hospitalName: '',
      announcement: '',
      hospitalList: '',
      boltPrefs: '',
      gaPermission: '',
      email: '',
      contactNumber: '',
      mobileNumber: '',
      hospitalCountry: '',
      hospitalState: '',
      hospitalStateCode: '',
      baxterRoles: '',
    },
  },
  actions: {
    /**
     * Returns if user is authenticated
     *
     * @param  {Function} ) [description]
     * @return boolean     [description]
     */
    IS_AUTHENTICATED: ({ commit }) => new Promise((resolve, reject) => {
      const tokenString = window.localStorage.getItem('_user');

      if (!tokenString) {
        resolve(false);
        return;
      }

      User
        .getSession()
        .then(({ data }) => {
          commit('authenticateUser', data);
          resolve(true);
        })
        .catch((err) => {
          reject(err);
        });
    }),
    /**
     * Authenticate user for application session
     *
     * @param  {Function} {username, password})   [description]
     * @return {[type]}               [description]
     */
    LOGIN_REQUEST: (state, { username, password }) => new Promise((resolve, reject) => {
      Login
        .authenticate(username, password)
        .then(({ data }) => {
          window.localStorage.setItem('_user', JSON.stringify(data));
          httpClient.defaults.headers.common.Authorization = `Bearer ${data.access_token}`;
          resolve(data);
        })
        .catch((err) => {
          reject(err);
        });
    }),
    /**
     * Logout authenticated user
     *
     * @param  {[type]} ) [description]
     * @return {[type]}   [description]
     */
    LOGOUT: ({ commit }) => new Promise((resolve) => {
      try {
        Login.logoutUser();
      } catch {
        window.localStorage.removeItem('_user');
        window.localStorage.removeItem('csrf_token');
        window.localStorage.removeItem('logout_token');
        commit('logout');
        resolve();
      }

      window.localStorage.removeItem('_user');
      window.localStorage.removeItem('csrf_token');
      window.localStorage.removeItem('logout_token');
      commit('logout');
      resolve();
    }),
  },
  mutations: {
    authenticateUser(state, payload) {
      state.authenticated = true;

      const {
        userId, firstName, lastName, hospitalName, hospitalList, boltPrefs, gaPermission, email, contactNumber, mobileNumber, hospitalCountry, hospitalState, hospitalStateCode, announcementNotices, announcementAlerts, content, baxterContent, baxterRoles
     } = payload;

      const sortedHospitalList = Object.entries(hospitalList); // _.sortBy(hospitalList);

      function sortFunction(a, b) {
        if (a[1] === b[1]) {
          return 0;
        }
        return (a[1] < b[1]) ? -1 : 1;
      }

      sortedHospitalList.sort(sortFunction);

      state.user.userId = userId;
      state.user.firstName = firstName;
      state.user.lastName = lastName;
      state.user.hospitalName = hospitalName;
      state.user.announcementNotices = announcementNotices;
      state.user.announcementAlerts = announcementAlerts;
      state.user.hospitalList = sortedHospitalList;
      state.user.boltPrefs = boltPrefs;
      state.user.gaPermission = gaPermission;
      state.user.email = email;
      state.user.contactNumber = contactNumber;
      state.user.mobileNumber = mobileNumber;
      state.user.hospitalCountry = hospitalCountry;
      state.user.hospitalState = hospitalState;
      state.user.hospitalStateCode = hospitalStateCode;
      state.user.content = content;
      state.user.baxterContent = baxterContent;
      state.user.baxterRoles = baxterRoles;
      state.user.checkPref = function (pref) {
        return ((state.user.boltPrefs).indexOf(pref) !== -1);
      };
    },
    logout(state) {
      state.authenticated = false;
      state.user.userId = '';
      state.user.firstName = '';
      state.user.lastName = '';
      state.user.hospitalName = '';
      state.user.announcementNotices = '';
      state.user.announcementAlerts = '';
      state.user.gaPermission = '';
      state.user.email = '';
      state.user.contactNumber = '';
      state.user.mobileNumber = '';
      state.user.hospitalCountry = '';
      state.user.hospitalState = '';
      state.user.hospitalStateCode = '';
      state.user.hospitalList = [];
      state.user.boltPrefs = [];
      state.user.content = [];
      state.user.baxterContent = [];
      state.user.baxterRoles = [];
      },
  },
  getters: {
    authenticatedUser: (state) => state.user,
  },
};
